/**
 * 매장·팩 조회용 공용 GraphQL 문서.
 * store(소비자 매장 상세), boss(사장 미리보기), admin(마스터 로그인) 등
 * 서로 다른 역할에서 재사용되므로 src/api에 둡니다.
 * @see docs/file-structure.md "공용 gql vs route api" 기준
 */
import { gql } from "../__generated__";

export const GET_STORE = gql(`
  query Store($storeId: Int!) {
    store(id: $storeId) {
      id
      lat
      lng
      title
      createdAt
      updatedAt
      address
      detailAddress
      navigationInfo
      naverPlaceUrl
      instagramUrl
      likes {
        id
        userId
        storeId
      }
      isLiked
      todaysProducts{
        id
        name
        price
        discountPrice
        userPrice
        img
        isDeleted
        saleEndTime
        quantity
        currentCount
        isEnd
        menus {
          id
          img
          menu {
            id
            name
            img
          }
         quantity
        }
        isSampleMenu
      }
      img
      contactNumber
      closingHours
      liveOrderNotice
      reviewImg
      reviewContent
      reserveTime
      pack {
        id
        category
        currentCount
        isOverTodayPickupTime
        isTodayEnabled
        isTomorrowEnabled
        userPrice
        price
        packItems {
          name
        }
      }
      isProductAllSoldOut
      reviewCount
      bestReview {
        id
        content
        createdAt
        isBestReview
        storeId
        reviewImages {
          id
          img
          createdAt
          updatedAt
        }
      }
      isDeleted
      isHidden
      availableStoreCoupon {
        id
        title
        discountValue
        minOrderPrice
        endAt
        maxUsageQuantity
        usageCount
        isExpired
        isSoldOut
        conditions {
          type
        }
      }
    }
  }
`);

export const STORE_SEARCH = gql(`
  query StoreSearch($keyword: String!, $lat: Float, $lng: Float) {
    storeSearch(keyword: $keyword, lat: $lat, lng: $lng) {
      id
      title
      img
      address
      distance
      seller {
        contactNumber
      }
    }
  }
`);

export const GET_PACK = gql(`
  query Pack($storeId: Int!) {
    pack(storeId: $storeId) {
      id
      category
      price
      discountPrice
      discountRate
      userPrice
      quantity
      description
      saleEndTime
      createdAt
      updatedAt
      currentCount
      isOverTodayPickupTime
      isTodayEnabled
      isTomorrowEnabled
      store {
        title
        reserveTime
        img
      }
      maxOrderQuantity
      isOverMaxQuantity
    }
  }
`);

export const GET_PACK_WITH_AVAILABLE_QUANTITY_TO_ORDER = gql(`
  query PackWithAvailableQuantityToOrder($storeId: Int!) {
    pack(storeId: $storeId) {
      id
      category
      price
      discountPrice
      discountRate
      userPrice
      quantity
      description
      saleEndTime
      createdAt
      updatedAt
      currentCount
      isOverTodayPickupTime
      isTodayEnabled
      isTomorrowEnabled
      store {
        title
        reserveTime
        img
      }
      maxOrderQuantity
      availableQuantityToOrder
      isOverMaxQuantity
    }
  }
`);
